const SAME_FIELD_PROPS = {
  options: null, min_value: null, max_value: null, required: true, name: 'custom',
}

export const CATEGORY = [
  'Fashion',
  'Beauty',
  'Otomotif',
  'F&B',
  'Mom & Kids',
  'Outdoor',
  'Elektronik',
  'Lain-lain',
]

export const FIELD_OPTIONS = {
  standar: {
    'Data Diri': [
      {
        ...SAME_FIELD_PROPS, name: 'email', section: 'personal', type: 'email', icon: 'https://storage.googleapis.com/komerce/assets/LP-Komclass/email.svg', label: 'Email', placeholder: 'Masukkan emailmu',
      },
      {
        ...SAME_FIELD_PROPS, name: 'name', section: 'personal', type: 'text', icon: 'https://storage.googleapis.com/komerce/assets/LP-Komclass/nama.svg', label: 'Nama', placeholder: 'Isi nama lengkapmu',
      },
      {
        ...SAME_FIELD_PROPS, name: 'phone', section: 'personal', type: 'tel', icon: 'https://storage.googleapis.com/komerce/assets/LP-Komclass/no_hp.svg', label: 'No. HP', placeholder: 'Masukkan nomor HP kamu',
      },
      {
        ...SAME_FIELD_PROPS, name: 'city', options: ['Pilihan 1'], section: 'personal', type: 'dropdown', icon: 'https://storage.googleapis.com/komerce/assets/LP-Komclass/asal_kota.svg', label: 'Asal Kota', placeholder: 'Masukkan Kota atau Kabupaten',
      },
      {
        ...SAME_FIELD_PROPS, name: 'tiktok_username', section: 'personal', type: 'text', icon: 'https://storage.googleapis.com/komerce/Komlabs/link.svg', label: 'TikTok Username', placeholder: 'Masukkan TikTok Username',
      },
      {
        ...SAME_FIELD_PROPS, name: 'category', options: CATEGORY, section: 'personal', type: 'dropdown', icon: 'https://storage.googleapis.com/komerce/Komlabs/category-plus.svg', label: 'Kategori', placeholder: 'Pilih Kategori',
      },
      {
        ...SAME_FIELD_PROPS, name: 'followers_count', section: 'personal', type: 'number', icon: 'https://storage.googleapis.com/komerce/icon/angka.svg', label: 'Jumlah Followers', placeholder: 'Masukkan Jumlah Followers',
      },
      {
        ...SAME_FIELD_PROPS, name: 'gmv_30_days', section: 'personal', type: 'number', icon: 'https://storage.googleapis.com/komerce/icon/angka.svg', label: 'GMV 30 Hari Terakhir', placeholder: 'Masukkan GMV',
      },
      {
        ...SAME_FIELD_PROPS, name: 'name', section: 'personal', type: 'text', icon: 'https://storage.googleapis.com/komerce/icon/teks.svg', label: 'Nama', placeholder: 'Isi nama lengkapmu',
      },
      {
        ...SAME_FIELD_PROPS, name: 'gender', options: ['Pria', 'Wanita'], section: 'personal', type: 'dropdown', icon: 'https://storage.googleapis.com/komerce/icon/dropdown.svg', label: 'Gender', placeholder: 'Pilih Gender',
      },
      {
        ...SAME_FIELD_PROPS, name: 'dob', section: 'personal', type: 'date', icon: 'https://storage.googleapis.com/komerce/icon/tanggal.svg', label: 'Usia', placeholder: 'Masukkan Usia',
      },
      {
        ...SAME_FIELD_PROPS, name: 'mcn_interest', options: ['Belum', 'Tertarik', 'Sudah jadi anggota MCN'], section: 'personal', type: 'dropdown', icon: 'https://storage.googleapis.com/komerce/icon/dropdown.svg', label: 'Tertarik menjadi anggota MCN Komlabs?', placeholder: 'Pilih opsi',
      },
      {
        ...SAME_FIELD_PROPS, name: 'content_type', options: ['Video', 'Live'], section: 'personal', type: 'dropdown', icon: 'https://storage.googleapis.com/komerce/icon/dropdown.svg', label: 'Tipe Konten', placeholder: 'Pilih Tipe Konten',
      },
      {
        ...SAME_FIELD_PROPS, name: 'other_platform', options: ['Shopee'], section: 'personal', type: 'dropdown', icon: 'https://storage.googleapis.com/komerce/icon/dropdown.svg', label: 'Platform Lainnya', placeholder: 'Pilih opsi',
      },
    ],
  },
  custom: {
    Custom: [
      {
        ...SAME_FIELD_PROPS, required: false, section: 'other', type: 'text', icon: 'https://storage.googleapis.com/komerce/icon/teks.svg', label: 'Text', placeholder: 'Ketik Disini',
      },
      {
        ...SAME_FIELD_PROPS, options: ['Pilihan 1'], required: false, section: 'other', type: 'dropdown', icon: 'https://storage.googleapis.com/komerce/icon/dropdown.svg', label: 'Dropdown', placeholder: 'Pilih Opsi',
      },
      {
        ...SAME_FIELD_PROPS, required: false, section: 'other', type: 'number', icon: 'https://storage.googleapis.com/komerce/icon/angka.svg', label: 'Angka', placeholder: 'Masukkan angka',
      },
      {
        ...SAME_FIELD_PROPS, required: false, section: 'other', type: 'date', icon: 'https://storage.googleapis.com/komerce/icon/tanggal.svg', label: 'Tanggal', placeholder: 'Pilih tanggal',
      },
    ],
  },
}
